export default el => {
	var end = document.querySelector('.strate-footer');

	document.addEventListener('scroll', () => {
		handle();
	})

	const handle = () => {
		var offset = 0;

		const endRect = end.getBoundingClientRect();
		const endOffset = endRect.y - endRect.height;


		if (endOffset > offset) {
			el.classList.remove('inactive');
			return
		}

		el.classList.add('inactive');
	}
};
